import Vue from 'vue';
import Component from 'vue-class-component';
import VueRouter from 'vue-router';
import { Authority } from '@/shared/security/authority';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
const FoHome = () => import('@/fo/pages/home/fo-home.vue');
const InscriptionPage = () => import('@/fo/pages/inscription-page/inscription-page.vue');
const PaymentStart = () => import('@/fo/pages/payment/payment-start.vue');
const PaymentEnd = () => import('@/fo/pages/payment/payment-end.vue');
const CgvPage = () => import('@/fo/pages/cgv-page/cgv-page.vue');
const MentionsLegales = () => import('@/fo/pages/mentions-legales-page/mentions-legales-page.vue');
const BOHome = () => import('@/bo/pages/home/bo-home.vue');
const Error = () => import('@/core/error/error.vue');
const Settings = () => import('@/bo/pages/account/settings/settings.vue');
const ResetPasswordInit = () => import('@/bo/pages/account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('@/bo/pages/account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('@/bo/pages/account/change-password/change-password.vue');
const JhiUserManagementComponent = () => import('@/bo/pages/admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('@/bo/pages/admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('@/bo/pages/admin/user-management/user-management-edit.vue');
const ExamCenter = () => import('@/bo/pages/entities/exam-center/exam-center.vue');
const ExamCenterUpdate = () => import('@/bo/pages/entities/exam-center/exam-center-update.vue');
const ExamCenterDetails = () => import('@/bo/pages/entities/exam-center/exam-center-details.vue');
const InscriptionUpdate = () => import('@/bo/pages/entities/inscription/inscription-update.vue');
const InscriptionDetails = () => import('@/bo/pages/entities/inscription/inscription-details.vue');
const ExamSessionUpdate = () => import('@/bo/pages/entities/exam-session/exam-session-update.vue');
const ExamSessionDetails = () => import('@/bo/pages/entities/exam-session/exam-session-details.vue');
const ExamSession = () => import('@/bo/pages/entities/exam-session/exam-session.vue');
const Inscription = () => import('@/bo/pages/entities/inscription/inscription.vue');

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: FoHome,
      children: [
        {
          path: '',
          name: 'InscriptionFo',
          component: InscriptionPage,
        },
        {
          path: 'cgu',
          name: 'CGU',
          component: CgvPage,
        },
        {
          path: 'mentions-legales',
          name: 'MentionsLegales',
          component: MentionsLegales,
        },
        {
          path: '/paymentStart',
          name: 'PaymentStart',
          component: PaymentStart,
        },
        {
          path: '/paymentEnd',
          name: 'PaymentEnd',
          component: PaymentEnd,
        },
        {
          path: '/forbidden',
          name: 'Forbidden',
          component: Error,
          meta: { error403: true },
        },
        {
          path: '/not-found',
          name: 'NotFound',
          component: Error,
          meta: { error404: true },
        },
      ],
    },
    {
      path: '/bo',
      name: 'BackOffice',
      component: BOHome,
      children: [
        {
          path: 'account/reset/request',
          name: 'ResetPasswordInit',
          component: ResetPasswordInit,
        },
        {
          path: 'account/reset/finish',
          name: 'ResetPasswordFinish',
          component: ResetPasswordFinish,
        },
        {
          path: 'account/password',
          name: 'ChangePassword',
          component: ChangePassword,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'account/settings',
          name: 'Settings',
          component: Settings,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'admin/user-management',
          name: 'JhiUser',
          component: JhiUserManagementComponent,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'admin/user-management/new',
          name: 'JhiUserCreate',
          component: JhiUserManagementEditComponent,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'admin/user-management/:userId/edit',
          name: 'JhiUserEdit',
          component: JhiUserManagementEditComponent,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'admin/user-management/:userId/view',
          name: 'JhiUserView',
          component: JhiUserManagementViewComponent,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-center',
          name: 'ExamCenter',
          component: ExamCenter,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-center/new',
          name: 'ExamCenterCreate',
          component: ExamCenterUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-center/:examCenterId/edit',
          name: 'ExamCenterEdit',
          component: ExamCenterUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-center/:examCenterId/view',
          name: 'ExamCenterView',
          component: ExamCenterDetails,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-session',
          name: 'ExamSession',
          component: ExamSession,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-session/new',
          name: 'ExamSessionCreate',
          component: ExamSessionUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-session/:examSessionId/edit',
          name: 'ExamSessionEdit',
          component: ExamSessionUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-session/:examSessionId/view',
          name: 'ExamSessionView',
          component: ExamSessionDetails,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'exam-session/:examCenterId',
          name: 'ExamSessionByExamCenter',
          component: ExamSession,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'inscription',
          name: 'Inscription',
          component: Inscription,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'inscription/:examSessionId',
          name: 'InscriptionByExamSession',
          component: Inscription,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'inscription/new',
          name: 'InscriptionCreate',
          component: InscriptionUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'inscription/:inscriptionId/edit',
          name: 'InscriptionEdit',
          component: InscriptionUpdate,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
        {
          path: 'inscription/:inscriptionId/view',
          name: 'InscriptionView',
          component: InscriptionDetails,
          meta: { authorities: [Authority.GESTIONNAIRE] },
        },
      ],
    },
  ],
});
